import { Typography } from '@mui/material';

import OverwatchModal from '../OverwatchModal';

import { type FeedbackModalProps } from './types';

const FeedbackModal: React.FC<FeedbackModalProps> = ({ handleClose }) => {
  return (
    <OverwatchModal
      title="Send Feedback"
      handleClose={handleClose}
      size="sm"
      primaryButton={<></>}
      secondaryButton={<></>}
    >
      <Typography variant="caption">Currently unavailble for use</Typography>
    </OverwatchModal>
  );
};

export default FeedbackModal;

// TODO: To be revived later on in August 2026
// const FeedbackModal: React.FC<FeedbackModalProps> = ({ handleClose, feedbackType = "system" }) => {
//   const { currentUser } = useContext(CurrentUserContext);
//   const debounceFunc = useRef(normalDebounce((fn) => fn())).current;

//   const [feedback, setFeedback] = useState<FeedbackCreate>({
//     ...DEFAULT_FEEDBACK,
//     name: `${currentUser?.firstName} ${currentUser?.lastName}`,
//     email: currentUser?.email as string,
//     companyId: currentUser?.defaultCompany?.id as string,
//     feedbackType,
//   });
//   const { isUploading, handleUploadImage, handleRemoveImage, files } = useFileUploader();

//   const [createFeedback, { loading }] = useMutation(CreateFeedbackDocument, {
//     variables: {
//       feedback: {
//         ...feedback,
//         signedIds: mapSignedBlobId(files)
//       }
//     },
//     onCompleted: () => {
//       displayNotification({
//         type: "success",
//         text: "Feedback sent successfully",
//       });
//       handleClose();
//     },
//     onError: (error) => {
//       displayNotification({
//         type: "error",
//         text: error.message,
//       });
//     },
//     refetchQueries: [GetFeedbacksDocument]
//   });

//   const disableSend = () => {
//     return !(feedback.name.length && feedback.text.length) || isUploading || loading;
//   }

//   return (
//     <OverwatchModal
//       title="Send Feedback"
//       handleClose={handleClose}
//       size="sm"
//       primaryButton={
//         <Button
//           variant="text"
//           disabled={disableSend()}
//           onClick={() => createFeedback()}>
//           {isUploading ? "Uploading..." : loading ? "Creating..." : "Send"}
//         </Button>
//       }
//       secondaryButton={
//         <Button onClick={handleClose}>
//           Cancel
//         </Button>
//       }
//     >
//       <Stack spacing={2}>
//         <Stack direction="row" spacing={2}>
//           <TextField
//             id="feedback-giver-name"
//             label="Name"
//             fullWidth
//             required
//             defaultValue={feedback.name}
//             disabled
//           />
//           <TextField
//             id="feedback-giver-email"
//             label="Email"
//             fullWidth
//             defaultValue={feedback.email}
//             disabled
//           />
//         </Stack>
//         <TextField
//           id="feedback-giver-feedback"
//           required
//           multiline
//           fullWidth
//           onChange={(e) => {
//             debounceFunc.cancel();
//             debounceFunc(() => {
//               setFeedback((prev) => ({ ...prev, text: e.target.value }))
//             })
//           }}
//           rows={4}
//           label="Text"
//         />
//       </Stack>
//       <Button
//         component="label"
//         variant="contained"
//         tabIndex={-1}
//         startIcon={<Attachment />}
//         sx={{ marginTop: 1 }}
//         disabled={arrayLength(feedback.signedIds) >= MAX_ATTACHMENTS_ALLOWED || !feedback.text.length || isUploading || loading}
//       >
//         {isUploading ? "Attaching..." : "Attach"}
//         <VisuallyHiddenInput
//           type="file"
//           accept={ACCEPTED_ATTACHMENT_FORMATS}
//           onChange={handleUploadImage}
//           disabled={arrayLength(feedback.signedIds) >= MAX_ATTACHMENTS_ALLOWED}
//         />
//       </Button>

//       {!isEmpty(files) &&
//         map(files, (file, index) => (
//           <UploadPreviewItem
//             file={file}
//             isUploading={isUploading}
//             key={`${index}-${file.id}`}
//             onRemove={() => handleRemoveImage(file.id)}
//           />
//         ))
//       }

//     </OverwatchModal>
//   );
// };
